


















































































	import {  RightHelper, Component } from "../../../Infrastructure/CorBase/CoreBase";
	import ReceiverListBase from "./ReceiverListBase";

	@Component
	export default class ReceiverList extends ReceiverListBase {

        getName() {
            return this.$store.state.notAssigned ? "receiversTableNotAssigned" :"receiversTable";
        }

		created() {	
			this.notAssigned = this.$store.state.notAssigned;
			super.initializeRights(undefined, 'CON_Receiver_Delete', 'CON_Receiver_Read', 'CON_Receiver_Update');			
			super.setTimer(this.$store.state.pageTimer);
			super.setDetailName('ReceiverDetail');			
			this.right_Provisioning = RightHelper.currentUserHasRight('COR_Component_Provisioning');
            this.setDeleteMessage(this.$t('receiver.messageQuestionMain').toString(), this.$t('receiver.messageQuestionMain2').toString(), this.$t('receiver.messageQuestionMain3').toString());

            super.created();
		};

        timer = 0;
        mounted() {
            this.timerHandle = setInterval(() => {
                this.timerRefresh();
            }, this.timerSecondRefresh);
        }

        beforeDestroy() {
            clearInterval(this.timerHandle);
        }

		selectedEditModal(item: any) {
			this.selectedEditModalBase(item);
        }

		changeTags(items: any, idLast: number) {
			this.changeTagsBase(items, idLast);
		}

		moreActionAddAllow(): boolean {		
			return this.moreActionAddAllowBase();
		}

		goBackDetailModal(item: any): void {
			this.goBackDetailModalBase(item, this.tableData);
		}

		goToTask(item: any): void {
            this.$router.push({ name: 'TaskDetail', params: { id: item.id.toString() }, query: { id: item.id.toString() } });
		}

        showAllertToDeleteClick(itemsSelected: any) {
            this.isDelete = true;
			//this.showAllertToDeleteClickBase(itemsSelected);
            this.countToRemove = itemsSelected != undefined ? ((typeof itemsSelected === 'number') ? 1 : (itemsSelected as Array<any>).length) : 1;
            if (this.$store.state.askBeforeDelete) {

                super.showAlertBeforeActionClickBase(itemsSelected, super.prepareRemoveMessage(), true);
            }
            else {
                this.itemsSelected = itemsSelected;
                this.callActionClick();
            }
		}

        showAllertToAddClick(itemsSelected: any) {
            this.isDelete = false;
            this.itemsSelected = itemsSelected;
			this.showAllertToAddClickBase(itemsSelected);
		}

		selectRows(items: any) {
			this.selectRowsBase(items);
		}

        showAddButton() {
			return RightHelper.currentUserHasRight('COR_Component_Provisioning') ;
		}

		titleAddMoreAtion() {
			return this.$t('receiver.add');
		}

		mainTitle() {
            return this.notAssigned ? this.$t('receiver.descriptionNotAssigned') : this.$t('receiver.description');
        }

		addNew() {
			this.addNewBase();
        }

		// VaP - toto zde musi byt, jinak nefunguje napojeni na tabulku
		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }
	};
